import { Mobile, Pc } from '../../hooks/MediaQuery'
import Page6Pc from './Page6Pc'
import Page6Mobile from './Page6Mobile'
import React, { useEffect, useState } from 'react'
import { selectMainBanner } from '../../api/x_banner'

function Page6() {
  const [banner, setBanner] = useState([])
  useEffect(() => {
    async function fetchBanner() {
      const response = await selectMainBanner({ code: 'BANNER_03' })
      const data = response.data.data
      setBanner(data)
    }
    fetchBanner()
  }, [])
  return (
    <>
      <Pc>
        <Page6Pc banner={banner} />
      </Pc>
      <Mobile>
        <Page6Mobile banner={banner} />
      </Mobile>
    </>
  )
}

export default Page6
